// export const api_url = "https://demo.firstste/pacademy.online/api/v1/";
// export const api_url = "https://myschool.firststepacademy.online/api/v1/";
export const api_url = "https://trucks-diagnosis.firststepacademy.online/api/v1/";